import { useQuery } from "@tanstack/react-query";
import { toastServerError } from "helpers";
import { ApiError, ApiServiceError } from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import { DamagedProductDetails } from "../../inventory.types";
import { requestGetDamagedItem } from "./getDamagedItem.request";

const useGetDamagedItem = (
  damagedItemId: string | undefined,
  options?: QueryOptions<DamagedProductDetails, ApiServiceError<ApiError>>
) => {
  const { data: damagedItem, ...rest } = useQuery({
    queryKey: ["inventory-manager-admin", "damaged-item", damagedItemId],
    queryFn: async () => await requestGetDamagedItem(String(damagedItemId)),
    onError: toastServerError,
    enabled: !!damagedItemId,
    cacheTime: 0,
    ...options
  });

  return { damagedItem, ...rest };
};

export default useGetDamagedItem;
